import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { RadarChart } from '@factorialco/f0-react/dist/experimental'
import {
  PerformanceProcessCompetenciesChartContentFragment,
  PerformanceReviewEvaluationQuery,
} from 'generated/resources/graphql'
import { maxBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { strategyChartColor } from 'modules/performance_process/lib/reviewStrategy'

type PerformanceRatingScaleOption = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          PerformanceReviewEvaluationQuery['performance']['reviewEvaluation']
        >['answeredQuestionnaires']
      >['answeredQuestionnaireWithSections']
    >['content'][number]['questions'][number]['question']['scale']
  >[number]
>

export const CompetenciesChart: React.FC<{
  scoreScale: PerformanceRatingScaleOption[]
  selfContent: PerformanceProcessCompetenciesChartContentFragment[]
  managerContent: PerformanceProcessCompetenciesChartContentFragment[]
}> = ({ scoreScale, selfContent, managerContent }) => {
  const competencies = new Map()

  if (!selfContent.length || !managerContent.length) {
    return null
  }

  const maxScoreScale = maxBy(scoreScale, 'value')?.value ?? 0

  for (const element of selfContent) {
    for (const answer of element.questions) {
      const competencyId = answer.question.metadata?.competencyId

      if (!competencyId) {
        continue
      }

      competencies.set(competencyId, {
        label: answer.question.title,
        values: {
          self: answer.answer?.answerRating?.value,
        },
      })
    }
  }

  for (const element of managerContent) {
    for (const answer of element.questions) {
      const competencyId = answer.question.metadata?.competencyId

      if (!competencyId) {
        continue
      }

      const selfCompetency = competencies.get(competencyId)

      competencies.set(competencyId, {
        label: answer.question.title,
        values: {
          manager: answer.answer?.answerRating?.value,
          self: selfCompetency?.values.self,
        },
      })
    }
  }

  const competenciesValues: { label: string; values: { manager: number; self: number } }[] =
    Array.from(competencies.values())

  return (
    <Box height="s600">
      <RadarChart
        dataConfig={{
          manager: {
            label: i18n.t('performance_process.competency_assessment.chart.legend.manager'),
            color: strategyChartColor('manager'),
          },
          self: {
            label: i18n.t('performance_process.competency_assessment.chart.legend.self'),
            color: strategyChartColor('self'),
          },
        }}
        data={competenciesValues}
        scaleMin={0}
        scaleMax={maxScoreScale}
      />
    </Box>
  )
}
